import { useEffect, useState } from "react";

/**
 * We needed a copy of useGetPaymentTypeVerbiage that was not dependent on the payment page context
 * Long term we probably need to just replace all uses with this one in order to not confuse thing.
 * @param {*} paymentType
 * @returns object with verbiage based on payment type
 */
export function usePaymentTypeVerbiage(paymentType = "donation") {
  const [verbiage, setVerbiage] = useState({});

  useEffect(() => {
    switch (paymentType?.toLowerCase()) {
      case "gift":
        return setVerbiage({
          leadText: "Make a Gift To",
          introButtonText: "Give Now!",
          verb: "give",
          noun: "gift",
          nounCap: "Gift",
          submitButtonText: "Give Securely",
        });
      case "payment":
        return setVerbiage({
          leadText: "Make a Payment Toward",
          introButtonText: "Make a Payment",
          verb: "pay",
          noun: "payment",
          nounCap: "Payment",
          submitButtonText: "Pay Securely",
        });
      case "donation":
      default:
        return setVerbiage({
          leadText: "Make a Donation To",
          introButtonText: "Donate Now!",
          verb: "donate",
          noun: "donation",
          nounCap: "Donation",
          submitButtonText: "Donate Securely",
        });
    }
  }, [paymentType]);

  return verbiage;
}
